module.exports = __webpack_public_path__ + "static/full-stack-project-covid-1-1e78dd8c61f677f7f5b9303287c42a66.png";